import { Suspense } from 'react';
import { CardsListSkeleton, Grid, Typography } from 'ui';

import { useGetBuyerMaterialSpecificationsAsAdmin } from '~/buyer-material-specifications/hooks/useGetBuyerMaterialSpecificationsAsAdmin/useGetBuyerMaterialSpecificationsAsAdmin';

import { BuyerMaterialSpecificationItem } from '../BuyerMaterialSpecificationItem/BuyerMaterialSpecificationItem';

type Props = {
  tradeCompanyId: number;
};

const ListSuspense = () => {
  return <CardsListSkeleton cardCount={3} cardRows={1} />;
};

export const BuyerMaterialSpecificationList = ({ tradeCompanyId }: Props) => {
  const { data: buyerMaterialSpecifications } = useGetBuyerMaterialSpecificationsAsAdmin({ tradeCompanyId });

  return (
    <Suspense fallback={<ListSuspense />}>
      {buyerMaterialSpecifications.length === 0 ? (
        <Typography>No material specifications found</Typography>
      ) : (
        <Grid container>
          {buyerMaterialSpecifications.map((spec) => (
            <Grid item xs={12} md={4} key={spec.id}>
              <BuyerMaterialSpecificationItem key={spec.id} buyerMaterialSpec={spec} />
            </Grid>
          ))}
        </Grid>
      )}
    </Suspense>
  );
};
